import React, { useState } from 'react'

export default function Converter(props) {
    const [text, setText] = useState("");
    const changeIt = (event) => {
        setText(event.target.value);
    }

    const clickUpIt = () => {
        let ch = text.toUpperCase();
        setText(ch);
    }

    const clickLowIt = () => {
        let ch = text.toLowerCase();
        setText(ch);
    }

    const clickClearIt = () => {
        setText("");
    }

    const clickCopyIt = () => {
        navigator.clipboard.writeText(text);
        props.showAlert("Text is copied to clipboard!", "success");
    }

    const clickTrimIt=() =>{
        let val = text.split(/[ ]+/);
        setText(val.join(" "));
    }

    function calcLength(){
        let len = 0;
        (text.split(/\s+/)).forEach(element => {
            len += element.length;
        });
        return len;
    }

    return (
        <div>
            <h3 className='mt-5'> {props.heading}</h3>
            <div className="mb-3">
                <textarea className="form-control" value={text} onChange={changeIt} id="exampleFormControlTextarea1" rows="7" style={{ backgroundColor: props.mode === "dark" ? "#212529" : "white", color: props.mode === "dark" ? "white" : "black" }}></textarea>
            </div>
            <button type="button" disabled={text.length === 0} className={`btn btn-${props.mode} me-2 mt-2`} onClick={clickUpIt}>UpperCase</button>
            <button type="button" disabled={text.length === 0} className={`btn btn-${props.mode} me-2 mt-2`} onClick={clickLowIt}>LowerCase</button>
            <button type="button" disabled={text.length === 0} className={`btn btn-${props.mode} me-2 mt-2`} onClick={clickClearIt}>Clear Text</button>
            <button type="button" disabled={text.length === 0} className={`btn btn-${props.mode} me-2 mt-2`} onClick={clickCopyIt}>Copy To Clipboard</button>
            <button type="button" disabled={text.length === 0}  className={`btn btn-${props.mode} me-2 mt-2`} onClick={clickTrimIt}>Remove Spaces</button>

            <h2 className='mt-3'>Text Summary</h2> 
            <p>{text.split(/\s+/).filter((element)=> {return element.length !== 0}).length} words and {/*text.length === 0?0:(text[text.length - 1] ===  ' ' || text[text.length - 1] === '\n' ? text.length - 1 : text.length)*/ calcLength()} characters</p> 
            <p>[<strong>{(text.split(/\s+/).filter((element)=> {return element.length !== 0}).length)*0.008} minutes </strong>taken to read]</p>
            <h2>Text Preview</h2>
            <div className="container-fluid border border-2">
                <p>{text.length > 0 ? text : "Write something in the above textbox to view here !!!"}</p>
            </div>
        </div>
    )
}
